import { render, staticRenderFns } from "./MultiCarousel.vue?vue&type=template&id=2708a9a3&scoped=true"
import script from "./MultiCarousel.vue?vue&type=script&lang=js"
export * from "./MultiCarousel.vue?vue&type=script&lang=js"
import style0 from "./MultiCarousel.vue?vue&type=style&index=0&id=2708a9a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2708a9a3",
  null
  
)

export default component.exports